<template>
  <div class="mall-toolbar-box">
    <a
      href="https://download.csdn.net/center?utm_source=csdn_dm_tb"
      target="_blank"
      :data-report-click="JSON.stringify({ spm: '3001.7954' })"
      data-report-query="spm=3001.7954"
      class="my-order"
    >学习中心</a>
    <a
      href="https://mp-edu.csdn.net/?utm_source=csdn_dm_tb"
      target="_blank"
      :data-report-click="JSON.stringify({ spm: '3001.7955' })"
      data-report-query="spm=3001.7955"
      class="my-order"
    >讲师后台</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cartTotal: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/ .toolbar-logo {
  display: none !important;
}
.mall-toolbar-box {
  font-size: 0;

  .my-order {
    display: inline-block;
    color: #222226;
    margin-right: 16px !important;
    font-size: 14px;
    cursor: pointer;
  }
  .car-box {
    display: inline-block;
    min-width: 106px;
    text-align: center;
    padding: 0 12px !important;
    position: relative;
    border: 1px solid #ccccd8;
    height: 32px;
    line-height: 30px;
    border-radius: 16px;
    margin-top: 8px !important;
    box-sizing: border-box !important;
    color: #222226;
    font-size: 14px;
    cursor: pointer;
    i {
      margin-right: 4px !important;
    }
    .icon {
      width: 18px;
      height: 18px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100% !important;
      vertical-align: middle;
    }

    .icon-car {
      background: url("@/assets/imgs/car_bar.png");
      margin-right: 2px;
      position: relative;
      top: -1px;
    }
  }
}
</style>
<style lang="less">

.custom_toolbar_content_active {
  color: #222226;
  vertical-align: top;
  display: inline-flex;
  align-items: center;
  border-top: 2px solid #fc5531;
  border-bottom: 2px solid #ffffff;
  padding-left: 10px !important;
  padding-right: 10px !important;
  height: 44px;
  box-sizing: content-box !important;
  &:hover {
    color: #222226;
    background: #f0f0f5ed;
    border-bottom: 2px solid #f0f0f5ed;
  }
}
.custom_toolbar_content_nomoral {
  color: #222226;
  display: inline-block;
  text-align: center;
  margin-right: 20px;
  margin: 0px 10px 0px 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  vertical-align: top;
  &:hover {
    color: #222226;
    background: #f0f0f5ed;
  }
}
</style>
